import { Box, Typography } from '@mui/material';
import { knowMoreInfoIconSrc } from '../../assets/wallet';

/** Figma 11051:14181/14182 — Know More dashed pill button */
function KnowMoreButton({ onClick }) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '7px',
        width: 190,
        height: 51,
        borderRadius: '100px',
        border: '2px dashed #ff00f2',
        bgcolor: 'rgba(19, 0, 53, 0.7)',
        boxShadow: 'inset 0 0 8px rgba(0, 0, 0, 0.55)',
        cursor: 'pointer',
        mx: 'auto',
        '&:hover': { opacity: 0.92 },
      }}
    >
      <Box
        component="img"
        src={knowMoreInfoIconSrc}
        alt=""
        sx={{ width: 20, height: 20, objectFit: 'contain', display: 'block', flexShrink: 0 }}
      />
      <Typography
        component="span"
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
          fontSize: 14,
          lineHeight: '20px',
          letterSpacing: '0.5px',
          color: '#ff00f2',
          whiteSpace: 'nowrap',
        }}
      >
        Know More
      </Typography>
    </Box>
  );
}

/** Figma 11051:14174 — currency info panel (blurred dark card) */
export default function WalletCurrencyInfoPanel({ icon, description, onKnowMore }) {
  if (!description) return null;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 441,
        mx: 'auto',
        borderRadius: '20px',
        bgcolor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(20px)',
        px: { xs: 2.5, sm: '28px' },
        py: { xs: 4, sm: '56px' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '30px',
      }}
    >
      <Box
        component="img"
        src={icon}
        alt=""
        sx={{
          width: 135,
          height: 144,
          objectFit: 'contain',
          display: 'block',
        }}
      />

      <Typography
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
          fontSize: 14,
          lineHeight: '24px',
          letterSpacing: '0.5px',
          color: '#fff',
          textAlign: 'center',
          maxWidth: 385,
        }}
      >
        {description}
      </Typography>

      <KnowMoreButton onClick={onKnowMore} />
    </Box>
  );
}
